import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import SidebarCollapse from "../../../app/SidebarCollapse";
import RadioInput from "../../../general/RadioInput";
import TextInput from "../../../general/TextInput";
import { EditableProps } from "../../editableProps";
import { updateNodeProperty } from "../../../../store/slices/BuilderSlice/builderSlice";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import "./styles.scss";
import DynamicDataSelectorInput from "@builder/components/general/DynamicSelectorInput";
import { useTranslation } from "react-i18next";
import { getValueAtPath } from "@builder/components/editable/helpers";

const TextEdit: React.FC<EditableProps> = ({ parent, excluded, noWrapper, path, customLabel, condition }: EditableProps) => {
    const dispatch = useAppDispatch();
    const selectedNode = useAppSelector(getSelectedNode);
    const [textType, setTextType] = useState<string>(!!selectedNode?.dynamicData ? "db" : "static");
    const { t } = useTranslation();

    useEffect(() => {
        if (selectedNode) {
            setTextType(!!selectedNode.dynamicData ? "db" : "static");
        }
    }, [selectedNode?.id]);

    if (!selectedNode) {
        return null;
    }

    if (condition && selectedNode && !condition(selectedNode)) {
        return null;
    }

    const value = getValueAtPath(selectedNode, path || ["text"]);

    const textTypeOptions = [
        {
            value: "static",
            img: "/static-text-icon.svg",
            checked: textType === "static",
            disabled: !!selectedNode?.dynamicData,
            tooltip: t("generalComponents.radioInput.Static")
        },
        { value: "db", img: "/db-icon.svg", checked: textType === "db", tooltip: t("generalComponents.radioInput.Dynamic") }
    ];

    const textTypeCallback = (value: string): void => {
        setTextType(value);
    };

    const staticTextCallback = (value: string): void => {
        dispatch(updateNodeProperty({ propertyPath: path || ["text"], value }));
    };

    if (noWrapper) {
        if (excluded?.includes("dynamic")) {
            return <TextInput title={customLabel || "Input text"} value={value} placeholder="Enter text" callback={staticTextCallback} />;
        } else {
            return (
                <>
                    <RadioInput groupName="textType" options={textTypeOptions} callback={textTypeCallback}></RadioInput>
                    {textType === "static" ? (
                        <TextInput title={customLabel || "Input text"} value={value} placeholder="Enter text" callback={staticTextCallback} />
                    ) : (
                        <DynamicDataSelectorInput />
                    )}
                </>
            );
        }
    } else {
        if (excluded?.includes("dynamic")) {
            return (
                <SidebarCollapse title={customLabel || "Text"} parent={parent}>
                    <TextInput title={customLabel || "Input text"} value={value} placeholder="Enter text" callback={staticTextCallback} />
                </SidebarCollapse>
            );
        } else {
            return (
                <SidebarCollapse title={customLabel || "Text"} parent={parent}>
                    <RadioInput groupName="textType" options={textTypeOptions} callback={textTypeCallback}></RadioInput>
                    {textType === "static" ? (
                        <TextInput title={customLabel || "Input text"} value={value} placeholder="Enter text" callback={staticTextCallback} />
                    ) : (
                        <DynamicDataSelectorInput />
                    )}
                </SidebarCollapse>
            );
        }
    }
};

export default TextEdit;
